import React, { FC } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import { setCountryAction } from '../../../../redux/features/country';
import DropdownGeneric from '../../../DropdownGeneric/DropdownGeneric';

export type CountriesType = {
  code: string;
  img: string;
};

const CountriesSelect: FC<{ isDark: boolean; countries: CountriesType[] }> = ({
  isDark = false,
  countries,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { country } = useParams<{ country: string }>();

  const selected =
    countries.find((c) => c.code === country) || countries[0];

 const onSelected = (option: string) => {
  const parts = window.location.pathname.split('/');

  const appIndex = parts.findIndex((seg) => seg === 'app');

  // Validación de seguridad
  if (appIndex === -1 || !parts[appIndex + 1]) {
    console.warn('Ruta inválida, no se encontró /app/{country}');
    return;
  }

  // Reemplaza el country
  parts[appIndex + 1] = option;

  const newPath = parts.join('/');

  dispatch(setCountryAction({ country: option }));
  navigate(newPath);
  window.location.reload();
};


  const title = (
    <div className="flex items-center gap-1">
      <img
        className="w-8"
        src={get(selected, 'img')}
        alt={get(selected, 'code')}
      />
    </div>
  );

  const items = map(countries, ({ code, img }) => ({
    name: (
      <div className="flex items-center gap-2">
        <img className="w-8 rounded-[4px]" src={img} alt={code} />
        <p className="uppercase">{code}</p>
      </div>
    ),
    onClick: () => onSelected(code),
  }));

  return (
    <div className="dropdown-country">
      <DropdownGeneric
        title={title}
        items={items}
        isDark={isDark}
      />
    </div>
  );
};

export default CountriesSelect;
